<template>
  <div class="pricing-input">
    <div class="form-group row">
      <div class="col-sm-12">
        <div v-for="(val, index) in value" :key="index" class="row">
          <div class="col-sm-6">
            <number-input
              v-model="val.lots"
              :options="{
                label: 'Lots',
                name: 'lots',
                value: val.lots,
                fullWidth: true
              }">
            </number-input>
          </div>
            <div class="col-sm-6">
            <currency-input
              v-model="val.amount"
              :options="{
                label: 'Cost',
                name: 'amount',
                value: val.amount,
                fullWidth: true
              }">
            </currency-input>
          </div>
          <div class="col">
            <button class="btn btn-danger btn-sm mb-1 float-right" type="button" @click.prevent="deleteItem(val)">
              <i class="fa fa-ban"></i> Remove
            </button>
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <button class="btn btn-info" type="button" @click.prevent="addNewItem()">
          <i class="fa fa-plus"></i> New
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import NumberInput from '@/components/inputs/NumberInput'
  import CurrencyInput from '@/components/inputs/CurrencyInput'
  import {
    validationClass,
    validationMessage
  } from '@/util/helpers'

  export default {
    name: 'PricingInput',
    props: {
      value: {
        type: Array
      },
      options: {
        type: Object,
        default () {
          return {
            valid: false,
            dirty: false
          }
        }
      }
    },
    components: {
      NumberInput,
      CurrencyInput
    },
    data () {
      return {
        isDirty: false,
        isValid: false,
        existing: []
      }
    },
    computed: {
      validationClass,
      validationMessage
    },
    methods: {
      validate (val = this.value) {
        this.$emit('input', val)
        this.isDirty = true
        if (Array.isArray(val) && val.length) {
          this.isValid = true
        } else if (this.options.required) {
          this.isValid = false
        } else {
          this.isValid = true
        }
      },
      deleteItem (val) {
        let values = this.value
        values.splice(values.indexOf(val), 1)
        this.$emit('input', values)
      },
      addNewItem () {
        let values = this.value
        values.push({
          lots: '',
          amount: '0'
        })
        this.$emit('input', values)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/PricingInput.vue